export const SANITY_PROJECT_ID = process.env.REACT_APP_SANITY_PROJECT_ID || "ynzo5m8g";
export const SANITY_DATASET = process.env.REACT_APP_SANITY_DATASET || "production";
